import Accordion from "./modules/accordion";
import Tabs from "./modules/tabs";
import MobileMenu from "./modules/mobile-menu";
import Animate from "./modules/animate";
import SiteSearch from "./modules/site-search";
import StickyHeader from "./modules/sticky-header";
import ResponsiveTable from "./modules/responsive-table";
import { popup } from "./modules/popup";

Accordion();

Tabs();

MobileMenu();

StickyHeader();

ResponsiveTable();

SiteSearch();

Animate();

popup();

//Disable Smooth Scroll
if (window.location.hash === "#feed") {
  document.documentElement.classList.add("scroll-auto");
}
